import React from "react";
import { FaBuilding, FaEnvelope, FaLinkedin, FaPhone, FaWhatsapp, FaMapMarkerAlt, FaClock, FaDirections } from "react-icons/fa";
import "./Contact.css";

const Contact = ({ t }) => {
  const phoneNumbers = [
    "+92 333 5127407",
    "+92 334 5239792",
    "+92 51 5172227"
  ];
  const emailAddresses = [
    "pakarabian@icloud.com",
    "info@pakarabian.com"
  ];
  const officeAddress = "Pak Arabian Manpower Services, 2nd Floor Midway Commercial, Attar Plaza, Bahria Town Phase VII, Islamabad, Pakistan";
  const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(officeAddress)}`;
  const mapEmbedUrl = `https://www.google.com/maps?q=${encodeURIComponent(officeAddress)}&output=embed`;
  const whatsappUrl = "https://wa.me/923335127407";
  const contactRows = [
    {
      key: "phone",
      icon: <FaPhone />,
      title: t.phone,
      content: phoneNumbers.map((phone) => (
        <a href={`tel:${phone.replace(/\s/g, "")}`} key={phone}>{phone}</a>
      )),
      clickable: true
    },
    {
      key: "email",
      icon: <FaEnvelope />,
      title: t.email,
      content: emailAddresses.map((email) => (
        <a href={`mailto:${email}`} key={email}>{email}</a>
      )),
      clickable: true
    },
    {
      key: "hours",
      icon: <FaClock />,
      title: t.hours,
      content: (
        <>
          <span>{t.days}</span>
          <span>{t.time}</span>
        </>
      )
    },
    {
      key: "whatsapp",
      icon: <FaWhatsapp />,
      title: "WhatsApp",
      content: (
        <a href={whatsappUrl} target="_blank" rel="noopener noreferrer">{t.whatsapp}</a>
      ),
      clickable: true
    },
    {
      key: "linkedin",
      icon: <FaLinkedin />,
      title: "LinkedIn",
      content: (
        <a href="https://www.linkedin.com/in/hamza-faisal-17557898" target="_blank" rel="noopener noreferrer">LinkedIn</a>
      ),
      clickable: true
    }
  ];

  return (
    <section className="contact-section" id="contact">
      <div className="contact-inner">
        <article className="office-panel" aria-labelledby="office-panel-title">
          <div className="office-eyebrow">
            <span><FaMapMarkerAlt /></span>
            {t.ourOffice || "Our Office"}
          </div>
          <h3 className="office-brand-title" id="office-panel-title">
            <span>Pak Arabian</span>
            <strong>Manpower Services</strong>
          </h3>
          <div className="office-address-block">
            <span className="office-address-icon"><FaBuilding /></span>
            <div>
              <h4>{t.office}</h4>
              <address>
                {t.address.map((line) => (
                  <span key={line}>{line}</span>
                ))}
              </address>
            </div>
          </div>
          <div className="office-map">
            <iframe
              src={mapEmbedUrl}
              title="Pak Arabian office location"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
          <a href={mapsUrl} target="_blank" rel="noopener noreferrer" className="map-link">
            <span className="map-link-icon"><FaDirections /></span>
            <span>
              <strong>{t.maps}</strong>
              <small>{t.directionsText || "Get directions to our office"}</small>
            </span>
          </a>
        </article>

        <div className="contact-content">
          <p className="section-kicker">{t.kicker}</p>
          <h2>{t.title}</h2>
          <p>
            {t.description}
          </p>
          <div className="contact-actions">
            <a href={`tel:${phoneNumbers[0].replace(/\s/g, "")}`} className="call-button">
              <FaPhone /> {t.callNow || "Call Us Now"}
            </a>
            <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="whatsapp-button">
              <FaWhatsapp /> {t.whatsapp}
            </a>
          </div>

          <div className="get-in-touch-label">
            <span></span>
            {t.getInTouch || "Get in Touch"}
            <span></span>
          </div>

          <div className="contact-info-list">
            {contactRows.map((row, index) => (
              <div
                className={`contact-row ${row.clickable ? "is-clickable" : ""}`}
                key={row.key}
                style={{ "--row-index": index }}
              >
                <span className="contact-row-icon">{row.icon}</span>
                <div className="contact-row-copy">
                  <h3>{row.title}</h3>
                  <div className="contact-row-body">{row.content}</div>
                </div>
                {row.clickable && <span className="contact-row-arrow">&rarr;</span>}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
